import { SVGProps, Ref, forwardRef } from 'react';

export const BoxFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M15.5 10.167c0 2.514 0 3.77-.781 4.552-.781.78-2.038.781-4.552.781H5.833c-2.514 0-3.77 0-4.552-.781C.501 13.938.5 12.68.5 10.167V7.2h15z"
                fill="currentColor"
            />
            <path
                d="M10.028.5c1.203 0 1.804 0 2.287.299.484.299.753.836 1.29 1.912L15.15 5.8H8.7V.5z"
                fill="currentColor"
            />
            <path
                d="M7.3 5.8H.85l1.545-3.09C2.932 1.636 3.2 1.099 3.685.8 4.168.5 4.769.5 5.972.5H7.3z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BoxFilledSize16Glyph.displayName = 'BoxFilledSize16Glyph';
